import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ palette, spacing, themeName }) => ({
  icon: {
    fontSize: spacing(6)
  },
  iconActive: {
    color: 'white'
  },
  title: {
    fontWeight: 700,
    ...(themeName === 'dacia' && {
      fontSize: 18,
      textTransform: 'uppercase'
    })
  },
  accorditionRoot: {
    boxShadow: 'none'
  },
  accorditionSummaryRoot: {
    padding: spacing(0, 3),
    '&$expanded': {
      color: palette.primary.contrastText,
      background: palette.primary.main,
      '& > div > h4': {
        color: palette.primary.contrastText
      }
    }
  },
  expanded: {}
}));
